import React from 'react';
import { useGtm } from '@unisporkal/tracking';
import { useGallery, useTrackShown } from 'app/hooks';
import IconChevronLeft from 'app/images/shared/chevron-left.svg';
import styles from './CorrectionsLanguagePreview.module.scss';

const CorrectionsLanguagePreview = () => {
  const gallery = useGallery();
  const gtm = useGtm();
  const trackShown = useTrackShown('correction_language');
  const previewData = gallery.queryCorrections?.language?.preview;

  const trackEvent = () => {
    gtm.prepareEvent('search', {
      ui_element_location: 'language_correction_preview',
    });
  };

  const getPreviewThumbs = () =>
    previewData.preview_thumbs.slice(0, 3).map((thumb) => (
      <img
        src={thumb}
        key={thumb}
        alt="preview"
        className={styles.thumb}
      />
    ));

  const shouldShow = () =>
    previewData?.translations &&
    previewData?.preview_thumbs.length > 0 &&
    previewData.url;

  if (shouldShow()) {
    trackShown();
    return (
      <div className={styles.preview}>
        <h3 className={styles.previewTitle}>
          {previewData.translations.title}
        </h3>
        <a
          href={previewData.url}
          onClick={trackEvent}
          data-testid="correction-preview"
        >
          <div className={styles.previewContainer}>
            <div className={styles.imagesContainer}>{getPreviewThumbs()}</div>
            <span className={styles.moreAssetsText}>
              {previewData.translations.results}{' '}
              <IconChevronLeft className={styles.arrowRight} />
            </span>
          </div>
        </a>
      </div>
    );
  }
  return null;
};

export default CorrectionsLanguagePreview;
